// *** ProfileCommunity Component ****
import React, { useEffect, useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import community1 from "../../assets/img/profile/communiy2.svg"
import { API } from "../../services/api";

const ProfileCommunity = (props) => {
    const Group = require("../../assets/img/Featured icon.jpg");
    
    return (
        <div>
            <Modal show={props.isCommunity} onHide={props.handleClose} dialogClassName="custom-modal">
                <Modal.Header closeButton>
                    <div className="popupheader">
                        <div>
                            <img src={Group} className="singupimage"></img>

                        </div>
                        <div className="header">
                            <h4 className="modal-tittle" >Community</h4>
                        </div>
                    </div>

                </Modal.Header>
                <Modal.Body>
                    <ul className="profile-community d-flex flex-wrap p-0 m-0">
                       {props.community?.map((community, index) => (
                       <li className="community-list-itm" >
                         <img src={API.uploadFilePath + community.communityId.profileImage?.url || community1} alt="test" className="community_thumb" />
                         <span>{community.communityId.communityName}</span>
                       </li>))}
                       

                        
                    </ul>

                </Modal.Body>
                <Modal.Footer className="modal-center" >
                    <Button variant="secondary" className="pop-primary" onClick={props.handleClose}>Close</Button>
                </Modal.Footer>
            </Modal>

        </div >
    );
};
export default ProfileCommunity;
